'use client';
import { Link } from '@mui/material';
import type { ReactNode } from 'react';

export type AnchorLinkProps = {
  target: string;
  children: ReactNode;
  scrollTopMargin?: string;
};

export default function AnchorLink({ children, target, scrollTopMargin }: AnchorLinkProps) {
  const handleClick = () => {
    if (target) {
      const element = typeof target === 'string' ? document.getElementById(`${target}`) : target;
      if (element) {
        if (scrollTopMargin) {
          element.style.scrollMarginTop = scrollTopMargin;
        }
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }
    }
  };

  return (
    <Link
      href={`#${target}`}
      rel="nofollow noopener noreferrer"
      target="_self"
      onClick={handleClick}
    >
      {children}
    </Link>
  );
}
